import { defineComponent as _defineComponent } from 'vue'


// Components
import PaymentConditionPill from "./PaymentConditionPill.vue"

interface Props {
	content: { [key: string]: string }
	height?: number
	width?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FlexiblePaymentConditionPill',
  props: {
    content: null,
    height: null,
    width: null
  },
  setup(__props: any) {

const props = __props as {
	content: { [key: string]: string }
	height?: number
	width?: number
};



return { __sfc: true,props, PaymentConditionPill }
}

})